(ns app.front.view.group.admin.integration.core
  (:require [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.integration.availability :as integration.availability]
            [app.front.view.group.admin.integration.back-end-system :as integration.back-end-system]
            [app.front.view.group.admin.integration.common :as iconf]
            [app.front.view.group.admin.integration.ecm :as integration.ecm]
            [app.front.view.group.admin.integration.model-codes :as integration.codes]
            [app.front.view.group.admin.integration.plan-review :as integration.plan-review]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-sub ::available-tabs
  :<- [::gas/group-features]
  :<- [::gas/backend-system-name]
  :<- [:tr]
  (fn [[features backend-system-name tr]]
    (concat (when (contains? features :group.feature/backend-system-integration)
              [{:item :integration-config/backend-integration
                :text (tr [:integration-config/backend-integration]
                          [backend-system-name])}])
            (when (or (contains? features :group.feature/external-plan-review-integration)
                      (contains? features :group.feature/enable-bluebeam))
              [{:item :integration-config.type/plan-review
                :text (tr [:integration-config.type/plan-review])}])
            (when (contains? features :group.feature/availability-integration)
              [{:item :integration-config.type/availability
                :text (tr [:integration-config.type/availability])}])
            (when (contains? features :group.feature/ecm-integration)
              [{:item :integration-config.type/ecm
                :text (tr [:integration-config.type/ecm])}])
            (when (contains? features :group.feature/model-codes-integration)
              [{:item :integration-config.type/model-codes
                :text (tr [:integration-config.type/model-codes])}]))))

(rf/reg-event-fx ::set-selected-tab
  (fn [{:keys [db]} [_ tab-id]]
    {:db (assoc-in db [::state :selected-tab] tab-id)
     :fx [[:dispatch [::iconf/cancel-editing]]]}))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::selected-tab
  :<- [::state]
  :<- [::available-tabs]
  :-> (fn [[{:keys [selected-tab]} tabs] _]
        (or selected-tab
            (-> tabs first :item))))

(defn view [match]
  (let [tr           (<sub [::gas/group-tr])
        group        (<sub [::gas/group])
        tabs         (<sub [::available-tabs])
        selected-tab (<sub [::selected-tab])]
    [acommon/admin-page
     {:match match
      :title (tr [:view/group.admin.integration])}
     (when (next tabs)
       [:div.flex.px-8
        (into
          (cc/content-switcher
            {:selected-index (p/find-index tabs {:item selected-tab})
             :class-name     ""
             :on-change      #(>evt [::set-selected-tab (->> % .-index (nth tabs) :item)])})
          (for [{:keys [text]} tabs]
            (cc/switch {:text text})))])

     (case selected-tab
       :integration-config/backend-integration
       [integration.back-end-system/view (util/mmap tr group)]

       :integration-config.type/plan-review
       [integration.plan-review/view (util/mmap tr group)]

       :integration-config.type/availability
       [integration.availability/view (util/mmap tr group)]

       :integration-config.type/ecm
       [integration.ecm/view (util/mmap tr group)]

       :integration-config.type/model-codes
       [integration.codes/view (util/mmap tr group)]

       nil)]))

(def route
  {:name        :view/group.admin.integration
   :view        view
   :public?     false
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path}]
                                (>evt [::gas/fetch-party-roles group-id])
                                (>evt [::template-subs/fetch-templates group-id]))
                  :stop       #(>evt [::iconf/cancel-editing])}]})
